export const loadScriptsInSequence = (
  scripts: HTMLScriptElement[],
  container: HTMLElement,
  index: number = 0 // Start from first script instead of last
): void => {
  if (!scripts || !scripts.length || index >= scripts.length) return;

  const script = scripts[index];
  container.appendChild(script);

  if (script.src) {
    // ✅ If it's an external script, wait for it to load before continuing
    script.onload = () => loadScriptsInSequence(scripts, container, index + 1);
  } else {
    // ✅ If it's an inline script, execute immediately
    loadScriptsInSequence(scripts, container, index + 1);
  }
};

export default { loadScriptsInSequence };

